import styles from '@/styles/myAccountLayout.module.scss'
import Link from 'next/link'
import { useState, useEffect } from "react"
import { useRouter } from 'next/router'
import myAccountApi from '@/service/modules/myAccountApi'

interface props {
  children: React.ReactNode
}

export default function Reviews({ children }: props) {
  const router = useRouter()
  const { pathname } = router

  interface dataInterface {
    customerID: number,
    firstName: string,
    lastName: string,
    level: number,
    valuedCustomer: string
  }
  const [customerData, setCustomerData] = useState<dataInterface | null>(null)
  // 获取用户信息
  const getCustomerInfo = async() => {
    try {
      let res = await myAccountApi.getCustomerInfo()
      if (res.data) {
        const data = {
          customerID: res.data?.customer.customerID,
          firstName: res.data?.customer.firstName,
          lastName: res.data?.customer.lastName,
          level: res.data?.customer.level,
          valuedCustomer: res.data?.valuedCustomer
        }
        setCustomerData(data)
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getCustomerInfo()
  }, [])


  // myaccount菜单
  const menuList = [
    { name: 'Order History', link: `/myaccount/order/0`, icon: 'csicon-Order-History' },
    { name: 'My Wishlist', link: `/myaccount/wishlist`, icon: 'csicon-My-Wishlist' },
    { name: 'Contact Information', link: `/myaccount`, icon: 'csicon-Contact' },
    { name: 'Address Manager', link: `/myaccount/address`, icon: 'csicon-Address-Manager' },
    { name: 'Credits & CrazyPoints', link: `/myaccount/credits`, icon: 'csicon-Credits' },
    { name: 'Login Details', link: `/myaccount/logindetails`, icon: 'csicon-Login-Details' },
    { name: 'My Status', link: `/myaccount/status`, icon: 'csicon-My-Status' },
  ]

  return (
    <div className={styles['my-account-layout']}>
      <div className={styles['wapper']}>
        {/* header部分 */}
        <div className={styles['my-account-header']}>
          <div className={styles["title-text"]}>My Account</div>

          {
            !!(customerData && customerData.customerID) &&
            <div className={styles['customer-info']}>
              <div className={styles["customer-name"]}>Hi&nbsp;{ customerData.firstName ? `${customerData.firstName} ${customerData.lastName ? customerData.lastName : ''}` : 'Customers' }</div>
              <div className={styles["customer-level"]}>
                Valued Customers：
                <Link 
                  href={'/legal/faq'}
                  passHref
                  legacyBehavior
                >
                  <a className={styles["customer-level-value"]} rel="noopener noreferrer">
                    {customerData.valuedCustomer} (level {customerData.level})
                  </a>
                </Link>
              </div>
            </div>
          }
        </div>

        {/* 主要内容 */}
        <div className={styles['my-account-box']}>
          <div className={styles['slider-list']}>
            {
              menuList.map(menu =>
                <Link 
                  key={menu.name}
                  href={menu.link}
                  passHref
                  legacyBehavior
                >
                  <a title={menu.name} rel="noopener noreferrer">
                    <div className={`${styles['slider-item']} ${ pathname === menu.link ? styles['active'] : '' } `}>
                      <i className={`iconfont ${menu.icon} ${styles['icon-menu']} `} />
                      { menu.name }
                    </div>
                  </a>
                </Link>
              )
            }
          </div>

          <div className={styles['content']}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}